export const ACADEMY_REMOVE_COMPONENT = 'academy/REMOVE_COMPONENT';

export default (componentId, screenId) => ({
  type: ACADEMY_REMOVE_COMPONENT,
  screenId,
  componentId,
});
